import update from 'immutability-helper'
import * as actionTypes from '../actions/actionTypes'

const initialState = {
  zakupLicencji: false,
  licencja: null,
  availableStructures: null,
  wyborStruktury: null,
  fileName: '',
  header: null,
  sections: null,
  name: '',
  dateFrom: '',
  dateTo: '',
  dataSporzadzenia: '',
  poczatekOkresu: '',
  koniecOkresu: '',
  validityErrors: null,
  actualValidityError: null,
  czyKRS: false,
  czyWylaczoneFormulyZZwK: false,
  err: '',
  isGUSLoading: false,
  czyPodsumowanie: false,
  czyTrwaSprawdzanie: false,
  czyTrwaImport: false,
  wyborDaty: false,
  paczkaZip: null,
}

const setCzyKRS = (state, { czyKRS }) => ({
  ...state,
  czyKRS,
})

const setCzyWylaczoneFormulyZZwK = (state, { value }) => ({
  ...state,
  czyWylaczoneFormulyZZwK: value,
})

const setCzyPodsumowanie = (state, { czyPodsumowanie }) => ({
  ...state,
  czyPodsumowanie,
})

const uploadFileSuccess = (state, { header, fileName }) => ({
  ...state,
  header,
  fileName,
})

const fetchSections = (state, { sections }) => ({
  ...state,
  sections,
})

const replaceSection = (state, { section, sectionType }) => {
  const index = state.sections.findIndex(x => x.TypSekcji === sectionType)
  return update(state, {
    sections: {
      [index]: { $set: section },
    },
  })
}

const setError = (state, { err }) => ({
  ...state,
  err,
})

const setGUSLoading = (state, { isGUSLoading }) => ({
  ...state,
  isGUSLoading,
})

const setCzyWyborDaty = (state, { wyborDaty, fileName }) => ({
  ...state,
  wyborDaty,
  fileName,
})

const setDataSporzadzenia = (state, { dataSporzadzenia }) => ({
  ...state,
  dataSporzadzenia,
})

const setOkresSprawozdania = (state, { poczatekOkresu, koniecOkresu }) => ({
  ...state,
  poczatekOkresu,
  koniecOkresu,
})

const setPaczkaZip = (state, { paczkaZip }) => ({
  ...state,
  paczkaZip,
})

const setCzyTrwaSprawdzanie = (state, { czyTrwaSprawdzanie }) => ({
  ...state,
  czyTrwaSprawdzanie,
})

const setCzyTrwaImport = (state, { czyTrwaImport }) => ({
  ...state,
  czyTrwaImport,
})

const setDates = (state, { dateFrom, dateTo }) => ({  
  ...state,
  dateFrom,
  dateTo,  
})

const setValidityErrors = (state, { validityErrors }) => ({
  ...state,
  validityErrors,
  actualValidityError:
    validityErrors && validityErrors.length !== 0 ? validityErrors[0] : null,
})

const setActualValidityError = (state, { actualValidityError }) => ({
  ...state,
  actualValidityError,
})

const setSectionData = (state, { name, value, index }) => {
  return update(state, {
    sections: {
      [index]: { Dane: { [name]: { $set: value } } },
    },
  })
}

const setSectionDataArray = (state, { value, elIndex, sIndex = 0, name }) => {
  return update(state, {
    sections: {
      [sIndex]: {
        Dane: { Pozycje: { [elIndex]: { [name]: { $set: value } } } },
      },
    },
  })
}

const setSectionDataCustomArray = (
  state,
  { value, elIndex, arrayName, name },
) => {
  return update(state, {
    sections: {
      0: {
        Dane: { [arrayName]: { [elIndex]: { [name]: { $set: value } } } },
      },
    },
  })
}

const setPozycjeUzytkownikaSkonsolid = (state, { iInfo, iCIT, v }) => {
  return update(state, {
    sections: {
      0: {
        Dane: {
          Pozycje: {
            [iInfo]: {
              InformacjaPodatkowa: {
                [iCIT]: { PozycjeUzytkownika: { $set: v } },
              },
            },
          },
        },
      },
    },
  })
}

const setPozycjeUzytkownikaSkonsolidV12 = (state, { iInfo, iCIT, v }) => {
  return update(state, {
    sections: {
      0: {
        Dane: {
          Pozycje: {
            [iInfo]: {
              InformacjaPodatkowa: {
                Pozycje: {
                  [iCIT]: { PozycjeUzytkownika: { $set: v } },
                },
              },
            },
          },
        },
      },
    },
  })
}

const setName = (state, { name }) => ({
  ...state,
  name,
})

const clearError = state => ({ ...state, err: '' })

const getNewObject = structure => {
  return {
    ...structure,
    ...{ Id: Date.now().toString() },
  }
}

const addDetailInfo = (state, { structure, sIndex = 0 }) => {
  return update(state, {
    sections: {
      [sIndex]: {
        Dane: {
          Pozycje: {
            $push: [getNewObject(structure)],
          },
        },
      },
    },
  })
}

const deleteDetail = (state, { index, sIndex = 0 }) => {
  return update(state, {
    sections: {
      [sIndex]: {
        Dane: {
          Pozycje: { $splice: [[index, 1]] },
        },
      },
    },
  })
}

const setLicence = (state, { licencja }) => {
  return {
    ...state,
    licencja,
  }
}

const setZakupLicencji = (state, { zakupLicencji }) => {
  return {
    ...state,
    zakupLicencji,
  }
}

const getAvailableStructures = (
  state,
  { availableStructures, wyborStruktury, fileName },
) => {
  return {
    ...state,
    availableStructures,
    wyborStruktury,
    fileName,
  }
}

const getStructureSelect = (state, { wyborStruktury }) => {
  return {
    ...state,
    wyborStruktury,
  }
}

const clearTable = (state, { arrayName }) => {
  return update(state, {
    sections: {
      0: {
        Dane: {
          [arrayName]: {
            $apply: items =>
              items.map(item =>
                update(item, {
                  KwotaA: { $set: 0 },
                  KwotaB: { $set: 0 },
                  KwotaB1: { $set: 0 },
                }),
              ),
          },
        },
      },
    },
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPLOAD_FILE_SUCCESS:
      return uploadFileSuccess(state, action)
    case actionTypes.FETCH_SECTIONS:
      return fetchSections(state, action)
    case actionTypes.REPLACE_SECTION:
      return replaceSection(state, action)
    case actionTypes.UPLOAD_FILE_FAIL:
    case actionTypes.DOWNLOAD_SECTIONS_FAIL:
    case actionTypes.SAVE_SECTIONS_FAIL:
    case actionTypes.DOWNLOAD_FILE_FAIL:
    case actionTypes.IMPORT_CSV_FAIL:
    case actionTypes.CHECK_VALIDITY_FAIL:
    case actionTypes.GET_LICENCE_FAIL:
    case actionTypes.LOGIN_FAIL:
    case actionTypes.DOWNLOAD_ATTACHMENT_FAIL:
      return setError(state, action)
    case actionTypes.CLEAR_ERROR:
      return clearError(state)
    case actionTypes.SET_SECTION_DATA:
      return setSectionData(state, action)
    case actionTypes.SET_SECTION_DATA_ARRAY:
      return setSectionDataArray(state, action)
    case actionTypes.SET_SECTION_DATA_CUSTOM_ARRAY:
      return setSectionDataCustomArray(state, action)
    case actionTypes.SET_POZYCJE_UZ_SKONS:
      return setPozycjeUzytkownikaSkonsolid(state, action)
    case actionTypes.SET_POZYCJE_UZ_SKONS_V12:
      return setPozycjeUzytkownikaSkonsolidV12(state, action)
    case actionTypes.SET_NAME:
      return setName(state, action)
    case actionTypes.ADD_DETAIL:
      return addDetailInfo(state, action)
    case actionTypes.DELETE_DETAIL:
      return deleteDetail(state, action)
    case actionTypes.CLEAR_TABLE:
      return clearTable(state, action)
    case actionTypes.SET_DATES:
      return setDates(state, action)
    case actionTypes.SET_VALIDITY_ERRORS:
      return setValidityErrors(state, action)
    case actionTypes.SET_ACTUAL_VALIDITY_ERROR:
      return setActualValidityError(state, action)
    case actionTypes.SET_CZY_KRS:
      return setCzyKRS(state, action)
    case actionTypes.SET_CZY_WYLACZONE_FORMULY_ZZWK:
      return setCzyWylaczoneFormulyZZwK(state, action)
    case actionTypes.GET_LICENCE_SUCCESS:
      return setLicence(state, action)
    case actionTypes.SET_ZAKUP_LICENCJI:
      return setZakupLicencji(state, action)
    case actionTypes.GET_STRUCTURES:
      return getAvailableStructures(state, action)
    case actionTypes.SET_STRUCTURE:
      return getStructureSelect(state, action)
    case actionTypes.SET_GUS_LOADING:
      return setGUSLoading(state, action)
    case actionTypes.SET_CZY_PODSUMOWANIE:
      return setCzyPodsumowanie(state, action)
    case actionTypes.SET_CZY_TRWA_SPRAWDZANIE:
      return setCzyTrwaSprawdzanie(state, action)
    case actionTypes.SET_CZY_TRWA_IMPORT:
      return setCzyTrwaImport(state, action)
    case actionTypes.SET_CZY_WYBOR_DATY:
      return setCzyWyborDaty(state, action)
    case actionTypes.SET_DATA_SPORZADZENIA:
      return setDataSporzadzenia(state, action)
    case actionTypes.SET_OKRES_SPRAWOZDANIA:
      return setOkresSprawozdania(state, action)
    case actionTypes.SET_PACZKA_ZIP:
      return setPaczkaZip(state, action)
    default:
      return state
  }
}

export default reducer
